import { render, staticRenderFns } from "./ConfigUserAccount.vue?vue&type=template&id=6f0ce5b5&"
import script from "./ConfigUserAccount.vue?vue&type=script&lang=js&"
export * from "./ConfigUserAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports